module.exports = __webpack_public_path__ + "assets/img/seal-a116ae97.png";